import { CreateApiStore } from "../helpers";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export default CreateApiStore({
  state: {
    id: "",
    tenantId: "",
    categories: []
  },
  getters,
  mutations,
  actions,
});
